'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  // Actually in use by App.js instances
  checkoutSignup: 'CheckoutSignup',
  crmSignup: 'CrmSignup',
  crmInvited: 'CrmInvited',
  salesSignup: 'SalesSignup',
  serviceSignup: 'ServiceSignup',
  salesInvited: 'SalesInvited',
  leadinSignup: 'LeadinSignup',
  marketingSignup: 'MarketingSignup',
  trial: 'Trial',
  trialSignup: 'TrialSignup',
  partnerClient: 'PartnerClientSignup',
  developersSignup: 'DevelopersSignup',
  academySignup: 'AcademySignup',
  hubspotForStartupsSignup: 'HubSpotForStartupsSignup',
  fbCrmSignup: 'FbCrmSignup',
  integrationsSignup: 'IntegrationsSignup',
  purchaseSignup: 'PurchaseSignup',
  classroomTrainingSignup: 'ClassroomTrainingSignup',
  salesPartnerSignup: 'SalesPartnerSignup',
  growthHubSignup: 'GrowthHubSignup',
  directoryUserSignup: 'DirectoryUserSignup',
  // content hub signups
  partnerContentHubSignup: 'PartnerContentHubSignup',
  developerContentHubSignup: 'DeveloperContentHubSignup'
};
module.exports = exports['default'];